import React from 'react';
import { register } from '../../i18n';
import GotoMenu from '../components/footer/GotoMenu';
import Navbar from '../components/footer/Navbar';

const t = register('AriaLabels');

const FooterLayout = () => {
  return (
    <footer aria-label={t('footer')} className='footer-wrapper'>
      <nav aria-label={t('slideNavigation')}>
        <GotoMenu />
        <Navbar />
      </nav>
    </footer>
  );
};

export default FooterLayout;
